import { displaySpots, getSpots, getMarkers, clearAllSpots as clearAllSpotsFromMap, clearSpotsArray } from './map.js';
import { resetPerformanceMetrics } from '../utils/performance-monitor.js';
import { LOGGING } from '/settings.js';

let favoritesActive = false;

export function clearAllSpots() {
    // Get current marker count before clearing
    const markers = getMarkers();
    const markerCount = markers.length;

    if (LOGGING.ENABLED && LOGGING.DEBUG && markerCount > 0) {
        console.log(`🧹 Clearing ${markerCount} existing markers...`);
    }

    // Use the new efficient clearAllSpots function from map.js
    clearAllSpotsFromMap();

    // Reset performance metrics after clearing to track new operations
    if (LOGGING.ENABLED && LOGGING.DEBUG) {
        resetPerformanceMetrics();
    }

    if (LOGGING.ENABLED && LOGGING.DEBUG && markerCount > 0) {
        console.log(`✅ Successfully cleared ${markerCount} markers`);
    }

    // Don't call displaySpots([]) as it's unnecessary and could cause infinite loops
}

export function showFavorites(favSpots) {
    displaySpots(favSpots, [], true); // Always pan/zoom when favorites button is pressed
}

export function showAllSpots() {
    displaySpots(getSpots());
    favoritesActive = false;
}

// Clears any search/filter UI or state. Components can listen for this event.
export function clearSearch() {
    window.dispatchEvent(new CustomEvent('clearSearch'));
    // Also clear the city selection in the search bar
    import('../header/header-search-bar.js').then(mod => {
        if (mod.initializeSearchBar) {
            mod.initializeSearchBar();
        }
    });
}
